import React from "react";

import cx from "classnames";

import styles from "./WaveformIndicator.module.css";

export interface WaveformIndicatorProps {
	/**
	 * Array of five amplitude percentages (0 – 100)
	 */
	amplitudes: number[];
	/**
	 * Additional class name(s) to apply to the outer container.
	 */
	className?: string;
}

/**
 * A simple audio waveform visual inspired by `audio.html` prototype.
 * It renders five vertical bars whose heights correspond to the
 * provided amplitude percentages.  Values are clamped to the range
 * 15 % (minimum visible) – 100 %.
 */
export default function WaveformIndicator({ amplitudes, className }: WaveformIndicatorProps) {
	// Ensure we always have exactly five bars.
	const padded = React.useMemo(() => {
		const out = amplitudes.slice(-5);
		while (out.length < 5) {
			out.unshift(15); // pad with minimum height
		}
		return out;
	}, [amplitudes]);

	return (
		<div className={cx(styles.container, className)}>
			{padded.map((pct, idx) => (
				// eslint-disable-next-line react/no-array-index-key
				<div key={idx} className={styles.bar} style={{ height: `${Math.max(15, Math.min(100, pct))}%` }} />
			))}
		</div>
	);
}
